export function degreeToRadian(degree) {
    return degree * Math.PI / 180;
}

export function transitionEnd(element, callbackFunc) {
    element.unbind('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd');
    element.bind('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', () => {
        element.unbind('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd');
        if (callbackFunc) {
            callbackFunc.apply();
        }
    });
}

export function animationEnd(element, callbackFunc) {
    element.unbind('animationend webkitAnimationEnd MSAnimationEnd oanimationend');
    element.bind('animationend webkitAnimationEnd MSAnimationEnd oanimationend', () => {
        element.unbind('animationend webkitAnimationEnd MSAnimationEnd oanimationend');
        if (callbackFunc) {
            callbackFunc.apply();
        }
    });
}

export function groupArrayByObjKey(arr, key) {
    return arr.reduce( (r, a) => {
        r[a[key]] = r[a[key]] || [];
        r[a[key]].push(a);
        return r;
    }, {});
}

export function hexToRgbA(hex, opacity){
    let c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + opacity + ')';
    }
    throw new Error('Bad Hex');
}
